export default "__VITE_ASSET__DXVwcB_j__"